module.exports = __webpack_public_path__ + "img/郑州办公室.7c4347e9.jpg";